import { useState } from "react";
import { CustomAbsolutePositionDropdownWrapper } from "./CustomDropdownWrapper";
import { Divider, Row, SizedBox } from "../CommonBaseComponents";
import { C3Text } from "../text/CustomText";
import CustomIcon from "../image/CustomIcon";
import SecondaryButton from "../button/SecondaryButton";
import PrimaryButton from "../button/PrimaryButton";
import Translate from "../../translate/Translate";
import { Theme } from "../../Theme";

export default function CheckedDropdownMenu({ initValue, setValue, values, onClose, openedLeftSide }) {
    const [currentValue, setCurrentValue] = useState(initValue);

    const applyValue = () => {
        setValue(currentValue);
        onClose();
    };

    return (
        <CustomAbsolutePositionDropdownWrapper openedLeftSide={openedLeftSide} width={"232px"}>
            <SizedBox height={"12px"} />
            {values.map((v) => (
                <SizedBox key={v.value} width={"100%"} height={"auto"} hoverBackgroundColor={Theme.color.neutral100}>
                    <Row
                        justifyContent={"space-between"}
                        padding={"10px 20px"}
                        cursor={"pointer"}
                        onClick={() => setCurrentValue(v.value)}
                        width={"100%"}
                    >
                        <C3Text fontColor={Theme.color.zinc850}>{v.label}</C3Text>
                        {currentValue === v.value && <CustomIcon iconName={"checked_active"} size={"15.5px"} />}
                    </Row>
                </SizedBox>
            ))}
            <Divider marginTop={"10px"} />
            <Row justifyContent={"flex-end"} padding={"12px"}>
                <SecondaryButton text={Translate("common.cancel")} onClick={onClose} />
                <SizedBox width={"7px"} />
                <PrimaryButton text={Translate("common.apply")} onClick={applyValue} />
            </Row>
        </CustomAbsolutePositionDropdownWrapper>
    );
}
